import { SUPPORTED_CONTENT_LANGUAGES, TRANSCRIPTOR_LANGUAGE } from '../config';

import { normalizeContentLanguage } from './normalizeContentLanguage';

// Maps the interface locale (e.g. 'en-US', 'ru', 'uk') to the content language
// used by transcriptor schemas. A locale outside the platform languages
// falls back to English so the schema list never ends up empty.
export const resolveContentLanguage = (
  locale: string,
): TRANSCRIPTOR_LANGUAGE => {
  const base = normalizeContentLanguage(locale);

  return SUPPORTED_CONTENT_LANGUAGES.includes(base as TRANSCRIPTOR_LANGUAGE)
    ? (base as TRANSCRIPTOR_LANGUAGE)
    : TRANSCRIPTOR_LANGUAGE.English;
};
